import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import isFunction from 'lodash/isFunction';
import { Popover, Radio } from 'antd';
import { MinusOutlined, EnvironmentOutlined, CiCircleOutlined, BorderOutlined } from '@ant-design/icons';

import './MapGeofenceType.css';

@inject('translationsStore')
@observer
export default class MapGeofenceCircle extends Component {
  constructor(props) {
    super(props);

    this.state = {
	  type: this.props.type ? this.props.type : '',
	  isNothing: this.props.type === '' ? true : false,
	  isCircle: this.props.type === 'CIRCLE' ? true : false,
	  isSquare: this.props.type === 'SQUARE' ? true : false,
	  isGeolocation: this.props.type === 'GEOLOCATION' ? true : false,
	  isCustomPolygon: this.props.type === 'CUSTOM' ? true : false,
	  visiblePopover: false
	};
	this.onChange(this.props.type ? this.props.type : '');
  }
  
  handlePopoverVisibleChange = visible => {
    this.setState({ visiblePopover: visible });
  };
  
  onTypeChange = (e) => {
    this.setState({ 
		type: e.target.value, 
		isNothing: (e.target.value === '' ? true : false )
		, isCircle: (e.target.value === 'CIRCLE' ? true : false )
		, isSquare: (e.target.value === 'SQUARE' ? true : false )
		, isGeolocation: (e.target.value === 'GEOLOCATION' ? true : false )
		, isCustomPolygon: (e.target.value === 'CUSTOM' ? true : false )
		, visiblePopover: false
	});
	this.onChange(e.target.value);
  };

  onChange = (type) => {
	if (isFunction(this.props.onChange)) {
      this.props.onChange(type);
    }
  }
	
  render() {
    const { translationsStore } = this.props;

    if (!(this.props.hasOwnProperty('visible') && !this.props.visible)) {
      return (
        <div className={`MapGeofenceType ${this.props.className || ''}`} style={this.props.style}>
			<Popover title={translationsStore.translate('mapGeofence.type.title')}
			  content={
				<div className="MapGeofenceTypeSelection">
				  <Radio.Group onChange={this.onTypeChange}>
					<Radio.Button value="CIRCLE"><CiCircleOutlined width={50} height={50} style={{ fontSize: '30px', padding: '10px' }} /><br/>{translationsStore.translate('mapGeofence.type.circle')}</Radio.Button>
					<Radio.Button value="SQUARE"><BorderOutlined width={50} height={50} style={{ fontSize: '30px', padding: '10px' }} /><br/>{translationsStore.translate('mapGeofence.type.square')}</Radio.Button>
					<Radio.Button value="GEOLOCATION"><EnvironmentOutlined width={50} height={50} style={{ fontSize: '30px', padding: '10px' }} /><br/>{translationsStore.translate('mapGeofence.type.geolocation')}</Radio.Button>
				  </Radio.Group>
				</div>
			  }
			  visible={this.state.visiblePopover}
			  onVisibleChange={this.handlePopoverVisibleChange}
			>
			  <div className={!this.state.isNothing ? 'hidden': null } style={{ textAlign: 'center' }}>
			    <MinusOutlined width={50} height={50} style={{ fontSize: '30px', padding: '10px' }} />
				<div style={{marginTop: 0}}>{translationsStore.translate('mapGeofence.type.select')}</div>
			  </div>
			  <div className={!this.state.isCircle ? 'hidden': null } style={{ textAlign: 'center' }}>
			    <CiCircleOutlined width={50} height={50} style={{ fontSize: '30px', padding: '10px' }} />
				<div style={{marginTop: 0}}>{translationsStore.translate('mapGeofence.type.circle')}</div>
			  </div>
			  <div className={!this.state.isSquare ? 'hidden': null } style={{ textAlign: 'center' }}>
			    <BorderOutlined width={50} height={50} style={{ fontSize: '30px', padding: '10px' }} />
				<div style={{marginTop: 0}}>{translationsStore.translate('mapGeofence.type.square')}</div>
			  </div>
			  <div className={!this.state.isGeolocation ? 'hidden': null } style={{ textAlign: 'center' }}>
			    <EnvironmentOutlined width={50} height={50} style={{ fontSize: '30px', padding: '10px' }} />
				<div style={{marginTop: 0}}>{translationsStore.translate('mapGeofence.type.geolocation')}</div>
			  </div>
			</Popover>
        </div>
      );
    } else {
      return <Fragment />;
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/components/MapGeofence/MapGeofenceType/MapGeofenceType.js